module.exports = __webpack_public_path__ + "static/media/tab4.f92f3bdd.png";